import { TitleInput, DescriptionInput, ImageInput } from "./FestivalInputs";
import { ShowPicker } from "./ShowPicker";
import { cn } from "@/app/_utils/cn";
import type { Festival } from "@/app/_services/FestivalService";

export const FestivalForm = ({
  control,
  errors,
  defaultFestival,
  onImageSelect,
  layout = "stacked",
}: {
  control: any;
  errors: any;
  defaultFestival?: Festival | null;
  onImageSelect: (dataUrl: string | null) => void;
  layout?: "stacked" | "split";
}) => {
  const isSplit = layout === "split";

  const imageInput = <ImageInput currentImage={defaultFestival?.img_url} onSelect={onImageSelect} tall={isSplit} />;

  return (
    <form
      id="festival-form"
      onSubmit={(e) => e.preventDefault()}
      className={cn(isSplit && "flex flex-col gap-6 md:flex-row")}
    >
      <div className={cn("grid gap-4", isSplit && "min-w-0 flex-1")}>
        {!isSplit && <div className="mb-1">{imageInput}</div>}
        <TitleInput control={control} errors={errors} />
        <DescriptionInput control={control} errors={errors} />
        <ShowPicker
          control={control}
          errors={errors}
          initialShows={defaultFestival?.shows?.map((s) => ({
            id: s.id,
            title: s.title,
            start: s.start,
          }))}
        />
      </div>
      {isSplit && <div className="w-full flex-none md:w-[340px]">{imageInput}</div>}
    </form>
  );
};
